import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";

const GOOGLE_REVIEWS_URL = "https://maps.app.goo.gl/LdnyQJJdFDEVK744A";

export default function PatientVoice() {
  return (
    <section className="bg-background-100 py-24 md:py-32 lg:py-40">
      <div className="u-container">
        <Reveal>
          <div className="mx-auto flex max-w-2xl flex-col items-center text-center">
            <SectionHeading en="GOOGLE REVIEWS" jp="Googleの口コミ" align="center" />

            <p className="mt-8 text-[13px] leading-[2.2] text-foreground-700 md:text-sm">
              ご来院いただいた皆さまから寄せられた口コミを、
              <br className="hidden sm:block" />
              Googleでご覧いただけます。
            </p>

            <a
              href={GOOGLE_REVIEWS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-10 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-8 py-3.5 text-[14px] font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              Googleの口コミを見る
              <i className="ri-arrow-right-line text-base" aria-hidden />
            </a>

            <p className="mt-4 text-[11px] tracking-wide text-foreground-600">
              ※Google Mapsへ移動します
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}